import type { NumberSpeller } from './types'

const ONES = ['సున్నా', 'ఒకటి', 'రెండు', 'మూడు', 'నాలుగు', 'ఐదు', 'ఆరు', 'ఏడు', 'ఎనిమిది', 'తొమ్మిది', 'పది',
  'పదకొండు', 'పన్నెండు', 'పదమూడు', 'పద్నాలుగు', 'పదిహేను', 'పదహారు', 'పదిహేడు', 'పద్దెనిమిది', 'పందొమ్మిది']
const TENS = ['', '', 'ఇరవై', 'ముప్పై', 'నలభై', 'యాభై', 'అరవై', 'డెబ్బై', 'ఎనభై', 'తొంభై']

function below100(n: number): string {
  if (n < 20) return ONES[n]
  return TENS[Math.floor(n / 10)] + (n % 10 ? ` ${ONES[n % 10]}` : '')
}

/** 100 = వంద, 150 = నూట యాభై, 200 = రెండు వందలు, 250 = రెండు వందల యాభై. */
function below1000(n: number): string {
  const h = Math.floor(n / 100)
  const r = n % 100
  if (!h) return below100(r)
  const hundred = h === 1 ? (r ? 'నూట' : 'వంద') : `${ONES[h]} ${r ? 'వందల' : 'వందలు'}`
  return r ? `${hundred} ${below100(r)}` : hundred
}

/** Counting form before వేలు/లక్షలు/కోట్లు: ఇరవై ఒకటి → ఇరవై ఒక్క. */
function adjective(words: string): string {
  return words.endsWith('ఒకటి') ? `${words.slice(0, -4)}ఒక్క` : words
}

function spell(n: number): string {
  if (n === 0) return ONES[0]
  const parts: string[] = []
  const crore = Math.floor(n / 10_000_000)
  const lakh = Math.floor((n % 10_000_000) / 100_000)
  const thousand = Math.floor((n % 100_000) / 1000)
  const rest = n % 1000
  if (crore) {
    parts.push(crore === 1 ? 'ఒక కోటి' : `${adjective(spell(crore))} ${n % 10_000_000 ? 'కోట్ల' : 'కోట్లు'}`)
  }
  if (lakh) parts.push(lakh === 1 ? 'ఒక లక్ష' : `${adjective(below100(lakh))} ${n % 100_000 ? 'లక్షల' : 'లక్షలు'}`)
  if (thousand) parts.push(thousand === 1 ? 'వెయ్యి' : `${adjective(below100(thousand))} ${rest ? 'వేల' : 'వేలు'}`)
  if (rest) parts.push(below1000(rest))
  return parts.join(' ')
}

export const te: NumberSpeller = {
  spell,
  year: spell,
  rupees: 'రూపాయలు'
}
